if (typeof AnnouncementCountdown === 'undefined') {
  class AnnouncementCountdown extends HTMLElement {
    static ATTRIBUTES = { expiresAt: 'expires-at' };
    static SELECTORS = { value: '[data-countdown-unit]' };
    static TICK_MS = 1000;
    static SECONDS_PER = { days: 86400, hours: 3600, minutes: 60, seconds: 1 };

    connectedCallback () {
      this._expiresAt = this._toTimestamp(this.getAttribute(AnnouncementCountdown.ATTRIBUTES.expiresAt));
      if (this._expiresAt === null) return this._expire();

      this._values = this._collectValues();
      this._tick();
      this._interval = setInterval(() => this._tick(), AnnouncementCountdown.TICK_MS);
    }

    disconnectedCallback () {
      clearInterval(this._interval);
    }

    _collectValues () {
      const elements = this.querySelectorAll(AnnouncementCountdown.SELECTORS.value);
      return Object.fromEntries([...elements].map((el) => [el.dataset.countdownUnit, el]));
    }

    _toTimestamp (value) {
      const timestamp = Date.parse(value ?? '');
      return Number.isNaN(timestamp) ? null : timestamp;
    }

    _tick () {
      const remaining = Math.floor((this._expiresAt - Date.now()) / 1000);
      if (remaining <= 0) return this._expire();
      this._render(remaining);
    }

    _render (remaining) {
      let rest = remaining;
      Object.entries(AnnouncementCountdown.SECONDS_PER).forEach(([unit, seconds]) => {
        const amount = Math.floor(rest / seconds);
        rest -= amount * seconds;
        if (this._values[unit]) this._values[unit].textContent = String(amount).padStart(2, '0');
      });
    }

    _expire () {
      clearInterval(this._interval);
      this.hidden = true;
    }
  }

  window.AnnouncementCountdown = AnnouncementCountdown;
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', window.AnnouncementCountdown);
}
